import { lazy, type ComponentType } from 'react';

/**
 * Wraps React.lazy with automatic page reload on chunk load failure.
 * After a deployment, users with cached index.html reference stale chunk
 * filenames that no longer exist. This detects the failure and forces a
 * single page reload to fetch the new index.html with correct chunk paths.
 */
export function lazyWithRetry<T extends ComponentType<any>>(
  importFn: () => Promise<{ default: T }>,
) {
  return lazy(() =>
    importFn().catch((error: unknown) => {
      const lastRetry = Number(sessionStorage.getItem('chunk-retry') || 0);
      if (Date.now() - lastRetry < 10_000) {
        throw error;
      }
      sessionStorage.setItem('chunk-retry', String(Date.now()));
      window.location.reload();
      return new Promise<never>(() => {});
    }),
  );
}
